var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;




























































































pug_html = pug_html + "\u003Ccheckout-back-link on-click=\"component.backToDashboard()\"\u003E\u003C\u002Fcheckout-back-link\u003E\u003Cdiv class=\"wizardbox centered highlighted\"\u003E\u003Cdiv class=\"header show\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"titlew\"\u003E{{component.dTicketDashboardWizardIntro.title}}\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E\u003Cdiv class=\"video-wrap\"\u003E\u003Cimg ng-src=\"{{component.dTicketDashboardWizardIntro.img}}\" style=\"width: max-content;\"\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cspan class=\"subtitle\"\u003E{{ component.dTicketDashboardWizardIntro.subtitle }}\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E{{component.dTicketDashboardWizardIntro.subsubtitle}}\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Ch3\u003EWo ist das Deutschlandticket gültig?\u003C\u002Fh3\u003E\u003Cbr\u003E\u003Cspan class=\"subsubtitle\"\u003EDas Deutschlandticket ist bundesweit gültig und ermöglicht deutschlandweite Fahrten im ÖPNV und SPNV aller teilnehmenden Verkehrsunternehmen, Landestarife und Verkehrsverbünde sowie im verbundfreien Raum. Reisende können also alle Busse und Bahnen des öffentlichen Regional- und Nahverkehrs in ganz Deutschland nutzen. Ausgenommen sind der Fernverkehr und Fahrten in der ersten Klasse.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Ch3 ng-if=\"component.beginDateDticket\"\u003EAb wann ist mein Deutschlandticket gültig?\u003C\u002Fh3\u003E\u003Cbr\u003E\u003Cspan class=\"subsubtitle\" ng-if=\"component.beginDateDticket\"\u003EWenn Sie die Vereinbarung zur Nutzung des D-Tickets sofort nach Abschluss des Checkouts digital signieren, ist die erste Gültigkeit der {{ component.beginDateDticket }}. Bitte beachten Sie, dass in der Regel die Bestellungen am 27. des laufenden Monats durchgeführt werden. Die finale erstmalige Gültigkeit können Sie bei Vertragsunterschrift entnehmen.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cspan class=\"error\" ng-if=\"!component.loading &amp;&amp; !component.salaryLoading &amp;&amp; component.hasActiveDTicket\"\u003EDiese Wahlleistung wird von Ihnen bereits genutzt.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan class=\"error\" ng-if=\"component.whitelistDisabled\"\u003ESie sind aktuell nicht berechtigt, fortzufahren. Bitte kontaktieren Sie zur Klärung Ihre Personalabteilung, vielen Dank.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cinner-html ng-if=\"!component.loading &amp;&amp; !component.hasSetupForDTicket\" bind-html-compile=\"component.salaryError\"\u003E\u003C\u002Finner-html\u003E\u003Cbr\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"component.goToDTicketCheckout()\" ng-disabled=\"component.hasActiveDTicket || !component.hasSetupForDTicket || component.loading || component.whitelistDisabled\"\u003EWeiter\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;